export const HEADER_HEIGHT = 128
export const HEADER_HEIGHT_SM = 108
export const HEADER_EXTENSION_HEIGHT = 60
export const HEADER_EXTENSION_HEIGHT_WITH_FILTERS = 106
